import script from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"
export * from "./TopNavigation.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__